const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:4000";

export { API_BASE_URL };
export default API_BASE_URL;